var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackingapps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.373,
    height: 44.76,
    viewBox: "0 0 38.373 44.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tracking_apps",
    "data-name": "tracking apps",
    transform: "translate(-8.293 -1.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M24,8.96a7.64,7.64,0,1,0,7.64,7.64A7.64,7.64,0,0,0,24,8.96Zm0,12.613a4.966,4.966,0,1,0,0-.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M39.693,17.987a9.987,9.987,0,0,1-2.667-.44v.76c0,5.413-3.227,10.227-5.587,13.747l-.48.707a108.4,108.4,0,0,1-6.973,9.2c-1.573-1.907-4.68-5.76-6.973-9.2L16.56,32c-2.36-3.52-5.6-8.333-5.6-13.747A13.027,13.027,0,0,1,30.08,6.787a9.933,9.933,0,0,1,.693-2.667A15.667,15.667,0,0,0,8.293,18.307c0,6.227,3.493,11.44,6.053,15.24l.467.693A132.815,132.815,0,0,0,23,44.907l1.013,1.187,1.013-1.187A133.094,133.094,0,0,0,33.213,34.24l.467-.707c2.547-3.8,6.04-9,6.04-15.227A2.589,2.589,0,0,1,39.693,17.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 6.667,
    cy: 6.667,
    r: 6.667,
    transform: "translate(33.333 1.333)",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingapps);
export default __webpack_public_path__ + "static/media/trackingapps.98ca6b6a72779a4c871c2c598d71813f.svg";
export { ForwardRef as ReactComponent };